import { useQueryClient } from '@tanstack/react-query';
import { useApiMutation } from '@/api/hooks/useMutation';
import { campaignKeys } from '@/api/queryKeys';

/**
 * Hook to decline a magic link invite.
 *
 * The magic link JWT is passed as the `Authorization` Bearer token; the gateway
 * derives the campaign/creator/invite ids from it and forwards the decline to
 * cas-campaigns-service.
 */
export function useDeclineInvite() {
  const queryClient = useQueryClient();

  return useApiMutation({
    mutationFn:
      (api) =>
      async ({ token }: { token: string }) => {
        const response = await api.campaigns.campaignsControllerDeclineCreatorInvite(
          `Bearer ${token}`
        );
        return response.data;
      },
    onSuccess: (_data, { token }) => {
      // Refetch the invite summary so a re-open reflects the DECLINED status.
      queryClient.invalidateQueries({ queryKey: campaignKeys.invite(token) });
    },
  });
}
